module.exports = __webpack_public_path__ + "img/s_marker_optimised.cbb49f76.svg";